import * as React from 'react';
import Slider from 'react-slick';
import { useTheme } from '../../../theme';

interface Props {
	images: string[];
}

const ImagesSlider: React.FC<Props> = ({ images }) => {
	const theme = useTheme('EveryPortCard').EveryPortCard;

	return (
		<Slider arrows={true} dots={true} className={theme.slider} autoplay={true}>
			{images.map((image, key) => {
				return (
					<div className={theme.image} key={key}>
						<div className={theme.image__thumb} style={{ backgroundImage: `url(${image})` }} />
					</div>
				);
			})}
		</Slider>
	);
};

export default ImagesSlider;
